import React from 'react';
const Error404 = () => {
    console.log(0);
    return ( <>
    error 404
    </> );
}
 
export default Error404;

 